import { render } from "./Wood.vue?vue&type=template&id=516903b0"
import script from "./Wood.vue?vue&type=script&lang=js"
export * from "./Wood.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__